<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { detectBrowserLocale, readPreferredLocale, writePreferredLocale } from "@/library/i18n";
import { DEFAULT_LOCALE, pathFor } from "@/seo/routes-manifest";
import { useScrollReveal } from "@/composables/use-scroll-reveal";

import SiteNav from "@/components/sections/site-nav.vue";
import SiteFooter from "@/components/sections/site-footer.vue";

useScrollReveal();

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

onMounted(() => {
  if (route.path !== "/") return;
  const preferred = readPreferredLocale();
  if (preferred === DEFAULT_LOCALE) return;
  const target = preferred ?? detectBrowserLocale();
  if (target === DEFAULT_LOCALE) return;
  writePreferredLocale(target);
  router.replace(pathFor("home", target));
});
</script>

<template>
  <UApp>
    <a href="#hero" class="skip-to-content">{{ t("a11y.skipToContent") }}</a>

    <SiteNav />

    <main>
      <router-view />
    </main>

    <SiteFooter />
  </UApp>
</template>
